<template>
<div id="c-body" :class="{'c-body':wrap}">
    <slot name="before-header"></slot>
	<slot name="header"></slot>
	<slot name="section"></slot>
    <slot name="footer"></slot>
</div>
</template>

<script>
export default {
    name: 'cBody',
    props: {
        //是否需要外层wrap
        wrap: {
            type: Boolean,
            default: true
        }
    }
};
</script>

<style lang="scss">
@import 'src/style/frequently.scss';
#c-body {
    &.c-body {
        max-width: 14.18rem;
        min-width: 13.58rem;
        margin: 0.3rem auto 0 auto;
        padding: 0.18rem 0.28rem;
        box-sizing: border-box;
        background-color: #fff;
        border: 1px solid #dee2e5;
        border-radius: 0.04rem;
        box-shadow: 1px 1px 14px 1px hsla(0, 0%, 39%, 0.2);
    }
    // 顶部header模块
    .c-body-header {
        padding: 0.18rem 0.3rem;
        background-color: #eff3f6;
        border-radius: 0.04rem;
        // 顶部header的一行
        .header-row {
            display: flex;
            width: 100%;
            align-items: center;
            justify-content: space-between;
            &:not(:nth-last-of-type(1)) {
                margin-bottom: 0.2rem;
            }
            .header-row-right,
            .header-row-left {
                display: flex;
                align-items: center;
            }
            .header-row-left {
                flex: 1 1 auto;
            }
            .header-row-right {
                flex: 0 0 auto;
            }
            .header-row-label {
                font-size: 0.16rem;
                margin-right: 0.1rem;
            }
            //搜索条
            .header-search {
                width: 2rem;
                margin-right: 0.06rem;
            }
            //绿色大按钮
            .header-button-primary {
                width: 1.78rem;
                height: 0.4rem;
                margin-right: 0.2rem;
                line-height: 0.4rem;
                border-radius: 0.04rem;
                background-color: $impColor;
                color: #fff;
                font-size: 0.16rem;
                text-align: center;
                cursor: pointer;
                transition: all 0.2s ease;
                box-sizing: border-box;
                &.small {
                    width: 1.56rem;
                    height: 0.32rem;
                    line-height: 0.32rem;
                    border-radius: 0.04rem;
                    font-size: 0.14rem;
                }
                &:hover {
                    background-color: #2c9f1a;
                }
            }
            //白色小按钮
            .header-button-ghost {
                display: flex;
                align-items: center;
                margin-right: 0.06rem;
                height: 0.34rem;
                background-color: #fff;
                border: 1px solid #dfe2e5;
                border-radius: 0.04rem;
                cursor: pointer;
                transition: border-color 0.3s ease;
                &:hover {
                    border-color: $impColor;
                }
                .header-button-ghost-span {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    padding: 0 0.12rem;
                    height: 30px;
                    line-height: 30px;
                    font-size: 12px;
                    min-width: 0.72rem;
                    flex: 1 1 auto;
                    &.left {
                        justify-content: flex-start;
                    }
                }
                //下拉图标
                .header-button-ghost-down {
                    width: 0.22rem;
                    height: 0.32rem;
                    border-left: 1px solid #dfe2e5;
                    background-position: -2.14rem -1.56rem;
                }
            }
            //预设日期列表
            .header-default-date {
                display: flex;
                align-items: center;
                .header-default-date-item {
                    position: relative;
                    color: #999;
                    font-size: 0.16rem;
                    cursor: pointer;
                    line-height: 0.34rem;
                    transition: color 0.2s ease;
                    margin-right: 0.24rem;
                    &::before {
                        content: '';
                        position: absolute;
                        left: 0;
                        bottom: 0;
                        width: 0;
                        height: 2px;
                        display: block;
                        background-color: $impColor;
                        transition: all 0.2s ease;
                    }
                }
                .header-default-date-item-selected,
                .header-default-date-item:hover {
                    color: #666;
                    &::before {
                        width: 100%;
                    }
                }
            }
            //日期选择器
            .ivu-date-picker {
                .ivu-input-icon {
                    background-image: url('../../assets/sprit.png');
                    -webkit-background-size: 440px 320px;
                    background-size: 440px 320px;
                    background-repeat: no-repeat;
                    background-position: -354px -122px;
                }
            }
        }
    }
    // 主体section模块
    .c-body-section {
        margin-top: 0.28rem;
        // 表格
        .c-body-table {
            width: 100%;
            border-collapse: collapse;
            border-spacing: 0;
            border-color: grey;
            .ivu-tag {
                padding: 0 0.04rem;
                margin: 0 0.02rem;
                font-size: 0.08rem;
                line-height: 0.18rem;
                height: 0.18rem;
                top: -1px;
                position: relative;
            }
            // 表头
            .table-thead {
                .table-tr {
                    font-size: 0.14rem;
                    color: #999;
                    height: 0.5rem;
                    line-height: 0.5rem;
                }
                // 表格排序
                .table-sort {
                    transition: all 0.2s ease;
                    & i {
                        transition: all 0.2s ease;
                    }
                    .table-sort-icon {
                        transform: rotate(180deg);
                    }
                    &.active {
                        font-weight: bold;
                        color: rgba($color: #000000, $alpha: 0.7);
                    }
                }
                // 表格排序
            }
            // tr
            .table-tr {
                line-height: 0.7rem;
                height: 0.7rem;
                font-size: 0.12rem;
                color: #585c64;
                border: $border;
                transition: background-color 0.5s ease;
                &.offer {
                    background: #eff3f6;
                }
                &.summary {
                    background-color: #eff3f6;
                    font-size: 0.16rem;
                    color: #333;
                }
                &:hover {
                    background-color: rgba(35, 197, 47, 0.1);
                }
                .table-td-btn {
                    color: #237ec5;
                    font-size: 0.14rem;
                    cursor: pointer;
                    &.disabled {
                        color: #999999;
                        cursor: default;
                    }
                }
                // 默认td
                .table-td-primary {
                    min-width: 0.6rem;
                    padding: 0 0.02rem;
                    white-space: nowrap;
                    text-align: center;
                    // 图标包裹
                    .icon-wrap {
                        display: flex;
                        justify-content: center;
                        align-items: center;
                    }
                    //下拉选项
                    .ivu-dropdown {
                        position: relative;
                        display: block;
                        .ivu-select-dropdown {
                            top: 0.5rem !important;
                            // 下拉列表
                            .dropdown-menu {
                                position: relative;
                                &.top-triangle {
                                    &::before {
                                        content: '';
                                        display: block;
                                        width: 0.1rem;
                                        height: 0.1rem;
                                        background-color: #fff;
                                        transform: rotate(45deg);
                                        position: absolute;
                                        left: 50%;
                                        margin-left: -0.05rem;
                                        top: -0.1rem;
                                        box-shadow: -2px -2px 1px rgba(100, 100, 100, 0.1);
                                    }
                                }
                                .ivu-dropdown-item {
                                    color: #237ec5;
                                    text-decoration: underline;
                                    padding: 0;
                                    .dropdown-item {
                                        padding: 0.07rem 0.16rem;
                                    }
                                }
                            }
                        }
                    }
                }
                // 长td
                .table-td-long {
                    position: relative;
                    max-width: 2.5rem;
                    width: 2.5rem;
                    padding: 0 0 0 0.2rem;
                    text-align: left;
                }
            }
        }
    }

    .c-body-footer {
        .footer-row {
            margin-top: 0.28rem;
            display: flex;
            justify-content: flex-end;
            align-items: center;
            .table-count {
                margin-right: 0.2rem;
                font-size: 0.14rem;
            }
            .ivu-page {
                .ivu-page-item {
                    width: 0.36rem;
                    height: 0.36rem;
                    line-height: 0.36rem;
                    & a {
                        margin: 0;
                    }
                }
            }
        }
    }
    // 项目数字
    .icon-count {
        color: $impColor;
        font-weight: bold;
        margin: 0 0.05rem;
    }
    // 包名状态图标
    .icon-auto {
        font-weight: bold;
        color: #cccccc;
        &.active {
            color: $impColor;
        }
    }
    //刷新图标
    .icon-refresh {
        width: 0.38rem;
        height: 0.34rem;
        text-align: center;
        line-height: 0.34rem;
        background-position: 0.02rem -2.02rem;
        cursor: pointer;
        &:hover {
            background-position: -0.7rem -2.02rem;
        }
    }
    .icon-operation {
        background-position: -0.7rem -2.35rem;
        cursor: pointer;
        width: 0.4rem;
        height: 0.67rem;
    }
    //勾选图标
    .icon-checkbox {
        display: flex;
        width: 0.14rem;
        height: 0.14rem;
        border: 1px solid #dfe2e5;
        border-radius: 0.04rem;
        cursor: pointer;
        transition-property: border-color, background-color;
        transition-duration: 0.4s;
        transition-timing-function: ease;
        &.active {
            background-color: #23c52f;
            border-color: #23c52f;
            background-position: -0.08rem -1.67rem;
        }
    }
    .icon-default-status {
        font-weight: bold;
        color: #cccccc;
    }
    //状态图标
    .icon-status {
        width: 6px;
        height: 6px;
        display: block;
        border-radius: 50%;
        position: absolute;
        top: 50%;
        margin-top: -3px;
        left: 0.1rem;
        &.status0 {
            background-color: #fd5f65;
        }
        &.status1 {
            background-color: $impColor;
        }
        &.status3 {
            width: 0.16rem;
            height: 0.16rem;
            margin-top: -0.07rem;
            background-position: -2.91rem -2.6rem;
            left: 0;
            background-color: #fff;
        }
        &.status4 {
            width: 8px;
            height: 13px;
            background-position: -1.51rem -1.3rem;
            margin-top: -6px;
            background-color: #fff;
        }
        &.status5 {
            background-color: #999;
        }
        &.status6 {
            background-color: #000;
            border-radius: 0 !important;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/commons/cBody.vue